<template>
  <PreAuthPage>
    <div class="sh-card__head">
      <LogoTile :branding="branding" :alt="tenantName" :size="44" />
      <span class="noaccess__badge"><v-icon size="20" color="warning">block</v-icon></span>
      <h1 class="sh-card__title">{{ t("noAccess.title", { app: tenantName }) }}</h1>
      <p class="sh-card__subtitle">{{ t("noAccess.text") }}</p>
      <!-- The one fact that resolves most "no access" tickets on the spot:
           which Passport this is. -->
      <p v-if="who" class="sh-whoami">{{ t("noAccess.signedInAs") }} <b>{{ who }}</b></p>
    </div>

    <!-- Sign-out forgets the token, so the next "Sign in" starts over —
         that is what "different account" means here. -->
    <v-btn class="noaccess__switch" color="primary" variant="flat" block @click="session.signOut()">{{
      t("noAccess.switchAccount")
    }}</v-btn>
    <v-btn
      v-if="support"
      class="noaccess__support"
      :href="support"
      :target="support.startsWith('mailto:') ? undefined : '_blank'"
      rel="noopener noreferrer"
      variant="text"
      size="small"
      block
      >{{ t("noAccess.contactSupport") }}</v-btn
    >
  </PreAuthPage>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useSessionStore } from "@/stores/session";
import { supportHref } from "@/app/loginLinks";
import LogoTile from "@/shell/LogoTile.vue";
import PreAuthPage from "@/shell/PreAuthPage.vue";
import { APP_BRANDING, APP_LOGIN_PAGE, APP_NAME } from "@/app";

export default defineComponent({
  name: "NoAccess",
  components: { LogoTile, PreAuthPage },
  setup() {
    const session = useSessionStore();
    const { t } = useI18n();
    const tenantName = APP_NAME;
    const branding = APP_BRANDING;
    const who = computed(() => session.user?.displayName || session.user?.userHash || null);
    const support = supportHref(APP_LOGIN_PAGE);
    return { t, session, tenantName, branding, who, support };
  },
});
</script>

<style scoped>
.noaccess__badge {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(var(--v-theme-warning), 0.14);
}
.noaccess__switch {
  font-weight: 600;
}
.noaccess__support {
  margin-top: 8px;
  font-size: 12px;
  color: var(--sh-text-60);
}
</style>
